module.exports = __webpack_public_path__ + "static/media/desktop-shapes.62f81374.png";